// extracted by mini-css-extract-plugin
export default {"data-table__container":"DataTable_data-table__container__dMZBc","table__wrapper":"DataTable_table__wrapper__zYy6x"};